import { Form, Modal } from "antd";
import { CurrencyInput } from "components/inputs";
import { LABEL_ALIGN } from "constants";

const Editar = ({ onFinish, closeModal }) => {
  const [form] = Form.useForm();
  const vdMaximo = Form.useWatch("seguro_maximo", form);
  const vdSinDocumentacion = Form.useWatch("seguro_sin_documentacion", form);

  return (
    <Modal
      width={350}
      title="Editar Valor Declarado"
      okText="Aplicar"
      open={true}
      onCancel={closeModal}
      onOk={() => form.submit()}
      destroyOnHidden
      okButtonProps={{ disabled: vdMaximo == null && vdSinDocumentacion == null }}
    >
      <Form
        form={form}
        onFinish={onFinish}
        labelAlign={LABEL_ALIGN}
        labelCol={{ flex: '180px' }}
      >
        <Form.Item
          label="VD máx. sin autorización"
          name="seguro_maximo"
        >
          <CurrencyInput style={{ width: 120 }} />
        </Form.Item>
        <Form.Item
          label="VD sin documentación"
          name="seguro_sin_documentacion"
          tooltip="Valor declarado asegurado máximo sin declaración fiscal respaldatoria."
        >
          <CurrencyInput style={{ width: 120 }} />
        </Form.Item>
      </Form>
    </Modal>
  );
}

export default Editar;